import type { AuthUser } from '@/shared/lib/auth/auth-provider'
import { PermissionLevel, Permissions } from '@/shared/lib/permissions/permission-values'

export function reportingLevel(user: AuthUser | null): number {
  if (!user) return PermissionLevel.NoAccess
  if (user.isSuperAdmin || user.isAdmin) return PermissionLevel.Admin
  return user.permissions[Permissions.ReportingCustom] ?? PermissionLevel.NoAccess
}

export interface ReportActions {
  canOpen: boolean
  canCreate: boolean
  canEdit: boolean
  canDuplicate: boolean
  canDelete: boolean
}

export function reportActions(level: number, isMine: boolean): ReportActions {
  const canCreate = level >= PermissionLevel.CreateEdit
  return {
    canOpen: level >= PermissionLevel.Read,
    canCreate,
    canEdit: canCreate && isMine,
    canDuplicate: canCreate,
    canDelete: level >= PermissionLevel.Delete && isMine,
  }
}

function isControlCharacter(character: string): boolean {
  const code = character.charCodeAt(0)
  return code <= 0x1f || code === 0x7f
}

export function csvFileName(reportName: string): string {
  const cleaned = Array.from(reportName.trim(), (character) =>
    isControlCharacter(character) || '\\/:*?"<>|'.includes(character) ? '-' : character,
  ).join('')
  return `${cleaned || 'report'}.csv`
}

/** The most rows POST /v1/reports/export returns; the file says when it was cut (spec 5.8). */
export const EXPORT_ROW_CAP = 50_000
